import { Card, Grid, Modal, Typography } from '@mui/material';
import { ClassicModal } from '../../Styles/Modal';
import { BlackButton, OutlinedWhiteButton } from '../../Styles/Button';
import api from '../../Api/api';

export const ModalDelete = (props) => {

   const {isDeleteOpen, setIsDeleteOpen, onUpdate, productId, token} = props;
   const handleDelete = async (productId) => {
     await api.deleteProduit(productId, token);
     onUpdate();
   }
 
   return (
     <ClassicModal sx={{
       width: "40%",
       height: "fit-content",
       margin: "auto",
       overflowY: "scroll",
       overflowX: "hidden",
       alignContent: "center"
       }}
       display="flex"
       open={isDeleteOpen}
       onClose={(e, reason) => (reason && reason === "backdropClick") ? setIsDeleteOpen(!isDeleteOpen) : null}
     >
       <Card id="modal" display="flex">
         <Grid
           display="flex"
           container
           padding={5}
           rowSpacing={3}
           columnSpacing={1}
           direction="row"
           margin="center"
           justifyItems="center"
           textAlign="center"
         >
           <Grid item xs={12}>
             <Typography>Êtes-vous sûr de vouloir supprimer ce produit ?</Typography>
             <Typography>Un produit ne devrait pas être supprimé si un ou plusieurs clients l'ont déjà acheté !</Typography>
           </Grid>
           <Grid item xs={6}>
             <OutlinedWhiteButton
               onClick={() => {
                 handleDelete(productId);
                 setIsDeleteOpen(false);
               }}
             >
               Supprimer
             </OutlinedWhiteButton>
           </Grid>
           <Grid item xs={6}>
             <BlackButton
               onClick={() => {
                 setIsDeleteOpen(false);
               }}
             >
               Annuler
             </BlackButton>
           </Grid>
         </Grid>
       </Card>
     </ClassicModal>
   )
}

export default ModalDelete;